import request from '@/utils/request';

export const overallApi = {
  /**
   * 企业专利
   * @returns
   */
  getMergePatents (params) {
    return request({
      url: '/merge/patents',
      method: 'get',
      params
    });
  },

  /**
   * 企业软著
   * @returns
   */
  getMergeSoftware (params) {
    return request({
      url: '/merge/software',
      method: 'get',
      params
    });
  },

  /**
   * 获取报告时间
   * @returns
   */
  getTaskTime (id) {
    return request({
      url: '/task/' + id,
      method: 'get'
    });
  },

  /**
   * 获取报告时间
   * @returns
   */
  getMergeReMergeTime (params) {
    return request({
      url: '/merge/re_merge/time',
      method: 'get',
      params
    });
  },

  /**
   * 更新报告
   * @returns
   */
  getMergeReMerge (params) {
    return request({
      url: '/merge/re_merge',
      method: 'PUT',
      params
    });
  },

  /**
   * 主体相关数量统计
   * @returns
   */
  getMergeSubjectStatistics (params) {
    return request({
      url: '/merge/subject/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 合并主体
   * @returns
   */
  getMergeSubject (params) {
    return request({
      url: '/merge/subjects',
      method: 'get',
      params
    });
  },

  /**
   * 企业top5行业指数
   * @returns
   */
  getMergeEvaluationIndustryIndexTops (params) {
    return request({
      url: '/merge/evaluation/industry_index/tops',
      method: 'get',
      params
    });
  },

  /**
   * 综合评价-评级
   * @returns
   */
  getMergeIndustryEvaluationComprehensiveGrade (params) {
    return request({
      url: '/merge/industry/evaluation/comprehensive/grade',
      method: 'get',
      params
    });
  },

  /**
   * 综合评价-行业技术研发实力
   * @returns
   */
  getMergeEvaluationComprehensiveTechRdStrength (params) {
    return request({
      url: '/merge/industry/evaluation/comprehensive/tech_rd_strength',
      method: 'get',
      params
    });
  },

  /**
   * 技术布局
   * @returns
   */
  getMergeEvaluationTechLayout (params) {
    return request({
      url: '/merge/evaluation/tech_layout',
      method: 'get',
      params
    });
  },

  /**
   * 技术布局-top5集群专利分布
   * @returns
   */
  getMergeEvaluationTechLayoutClusterPatentDistribution (params) {
    return request({
      url: '/merge/evaluation/tech_layout/cluster_patent_distribution',
      method: 'get',
      params
    });
  },

  /**
   * 技术布局-所在集群内所有企业布局分布
   * @returns
   */
  getMergeEvaluationTechLayoutClusterCompanyLayoutDistribution (params) {
    return request({
      url: '/merge/evaluation/tech_layout/cluster_company_layout_distribution',
      method: 'get',
      params
    });
  },

  /**
   * 技术评级 （技术质量结论）
   * @returns
   */
  getMergeEvaluationTechLevel (params) {
    return request({
      url: '/merge/evaluation/tech_level',
      method: 'get',
      params
    });
  },

  /**
   * 技术评级 - 专利星级
   * @returns
   */
  getMergeEvaluationTechLevelPatentStar (params) {
    return request({
      url: '/merge/evaluation/tech_level/patent_star',
      method: 'get',
      params
    });
  },

  /**
   * 技术影响 (结论)
   * @returns
   */
  getMergeEvaluationTechInfluence (params) {
    return request({
      url: '/merge/evaluation/tech_influence',
      method: 'get',
      params
    });
  },

  /**
   * 技术影响-企业专利被引用概况 (列表)
   * @returns
   */
  getMergeEvaluationTechInfluencePatentCited (params) {
    return request({
      url: '/merge/evaluation/tech_influence/patent_cited',
      method: 'get',
      params
    });
  },

  /**
   * 技术迭代速率
   * @returns
   */
  getMergeEvaluationTechIterationRate (params) {
    return request({
      url: '/merge/evaluation/tech_iteration_rate',
      method: 'get',
      params
    });
  },

  /**
   * 技术迭代速率-top5集群技术迭代速率
   * @returns
   */
  getMergeEvaluationTechIterationRateClusterTechIterationTate (params) {
    return request({
      url: '/merge/evaluation/tech_iteration_rate/cluster_tech_iteration_tate',
      method: 'get',
      params
    });
  },

  /**
   * 技术更新周期
   * @returns
   */
  getMergeEvaluationTechUpdateCycle (params) {
    return request({
      url: '/merge/evaluation/tech_update_cycle',
      method: 'get',
      params
    });
  },

  /**
   * 研发效率
   * @returns
   */
  getMergeEvaluationRdEfficiency (params) {
    return request({
      url: '/merge/evaluation/rd_efficiency',
      method: 'get',
      params
    });
  },

  /**
   * 研发效率-企业研发效率分布
   * @returns
   */
  getMergeEvaluationRdEfficiencyDistribution (params) {
    return request({
      url: '/merge/evaluation/rd_efficiency/distribution',
      method: 'get',
      params
    });
  },

  /**
   * 研发稳定性-研发人员留存分布
   * @returns
   */
  getMergeEvaluationRdStabilityRdStaffRetentionDistribution (params) {
    return request({
      url: '/merge/evaluation/rd_stability/rd_staff_retention_distribution',
      method: 'get',
      params
    });
  },

  /**
   * 研发稳定性
   * @returns
   */
  getMergeEvaluationRdStability (params) {
    return request({
      url: '/merge/evaluation/rd_stability',
      method: 'get',
      params
    });
  },

  /**
   * 产学研合作概况
   * @returns
   */
  getMergeEvaluationCooperationList (params) {
    return request({
      url: '/merge/evaluation/cooperation/list',
      method: 'get',
      params
    });
  },

  /**
   * 产学研合作
   * @returns
   */
  getMergeEvaluationCooperation (params) {
    return request({
      url: '/merge/evaluation/cooperation',
      method: 'get',
      params
    });
  },

  /**
   * 全球分布
   * @returns
   */
  getMergeEvaluationGlobalDistribution (params) {
    return request({
      url: '/merge/evaluation/global_distribution',
      method: 'get',
      params
    });
  },

  /**
   * 企业人员统计
   * @returns
   */
  getMergeStaffStatistics (params) {
    return request({
      url: '/merge/staff/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 企业人员
   * @returns
   */
  getMergeStaff (params) {
    return request({
      url: '/merge/staff',
      method: 'get',
      params
    });
  },

  /**
   * 企业投资机构信息统计
   * @returns
   */
  getMergeCompanyInvestorStatistics (params) {
    return request({
      url: '/merge/company/investor/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 企业投资机构信息
   * @returns
   */
  getMergeCompanyInvestor (params) {
    return request({
      url: '/merge/company/investor',
      method: 'get',
      params
    });
  },

  /**
   * 企业亮点统计
   * @returns
   */
  getMergeHighlightsStatistics (params) {
    return request({
      url: '/merge/highlights/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 企业亮点
   * @returns
   */
  getMergeHighlights (params) {
    return request({
      url: '/merge/highlights',
      method: 'get',
      params
    });
  },

  /**
   * 企业开庭公告
   * @returns
   */
  getMergeCourtAnnouncement (params) {
    return request({
      url: '/merge/court_announcement',
      method: 'get',
      params
    });
  },

  /**
   * 获取企业名称
   * @returns
   */
  getMergeSubjectsCompany (params) {
    return request({
      url: '/merge/subjects/company',
      method: 'get',
      params
    });
  },

  /**
   * 企业开庭公告统计
   * @returns
   */
  getMergeCourtAnnouncementStatistics (params) {
    return request({
      url: '/merge/court_announcement/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 企业被执行
   * @returns
   */
  getMergeExecuted (params) {
    return request({
      url: '/merge/executed',
      method: 'get',
      params
    });
  },

  /**
   * 企业被执行统计
   * @returns
   */
  getMergeExecutedStatistics (params) {
    return request({
      url: '/merge/executed/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 企业经营异常
   * @returns
   */
  getMergeAbnormalOperation (params) {
    return request({
      url: '/merge/abnormal_operation',
      method: 'get',
      params
    });
  },

  /**
   * 企业经营异常统计
   * @returns
   */
  getMergeAbnormalOperationStatistics (params) {
    return request({
      url: '/merge/abnormal_operation/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 企业技术风险
   * @returns
   */
  getMergeEvaluationRisk (params) {
    return request({
      url: '/merge/evaluation/risk',
      method: 'get',
      params
    });
  },

  /**
   * 企业资质认证统计
   * @returns
   */
  getMergeQualificationsStatistics (params) {
    return request({
      url: '/merge/qualification/statistics',
      method: 'get',
      params
    });
  },

  /**
   * 企业资质认证
   * @returns
   */
  getMergeQualifications (params) {
    return request({
      url: '/merge/qualifications',
      method: 'get',
      params
    });
  },

  /**
   * 企业行业信息
   * @returns
   */
  getMergeIndustry (params) {
    return request({
      url: '/merge/industry',
      method: 'get',
      params
    });
  },

  /**
   * 整体合并评价报告
   * @returns
   */
  getReportMergeEvaluation (params) {
    return request({
      url: '/report/merge/evaluation',
      method: 'get',
      params
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/merge/overall.js